<script lang="ts">
	//Design system components
	import { Alert, Button, Loader, Radio } from '@Shelly/shelly-design-system';
	import SettingGuide from '../../SettingGuide.svelte';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { get_gen_2_component_from_category, real_id } from 'src/helpers/interface_helpers';
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from 'svelte-i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	export let device;

	let loading = false;
	let supportedCTTypes: string[];
	const component = get_gen_2_component_from_category(device) || 'em';
	let value: string = readDeviceSettings(device.id)?.[`${component}:${device.channel}`]?.ct_type;
	let cache: string;

	$: settingsStore = getDeviceSettings(device.id);
	let settings = readDeviceSettings(device.id);
	$: settings = $settingsStore ?? settings;

	const setCTType = async () => {
		loading = true;
		const res = await gen2Request(device, `${component}.SetConfig`, {
			id: device.channel,
			config: {
				ct_type: value,
			},
		});
		await onSettingsResponse(res, device);
		loading = false;
	};

	const getData: () => Promise<string[]> = async () => {
		const res = await gen2Request(device, `${component}.GetCTTypes`, {
			id: device.channel,
		});

		supportedCTTypes = ['50A'];

		if (res.isok && res?.data?.supported) {
			supportedCTTypes = res?.data?.supported;
		}

		value =
			supportedCTTypes[
				supportedCTTypes.indexOf(settings[`${component}:${device.channel}`]?.ct_type)
			];
		cache = value;

		return supportedCTTypes;
	};
</script>

<SettingGuide
	text={$format('settings_guide_change_ct_type', {
		default:
			'Tell the device which current transformer (CT) is connected so power readings match the clamp. Choose the rating printed on the CT.',
	})}
/>

{#await getData()}
	<Loader />
{:then _}
	{#if supportedCTTypes.length === 1}
		<Alert
			type="info"
			heading={$format('alert_device_supports_one_ct', {
				default: 'The device only supports one type of CT.',
			})}
		/>
	{/if}
	{#each supportedCTTypes as type, i}
		<Radio class="mb-s" size="m" bind:selected={value} value={type} id="radio-lfvqb3w">{type}</Radio>
	{/each}
{/await}

<Button {loading} width="full" size="m" on:click={setCTType}>{$format('button_save')}</Button>
